// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".circular[data-v-419c9d02] {\n  border-radius: 50%;\n}\n.chat-icon[data-v-419c9d02] {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n  transition: all 0.3s ease;\n}\n.chat-icon[data-v-419c9d02]:hover {\n  transform: scale(1.1);\n  filter: brightness(1.2);\n}", ""]);
// Exports
module.exports = exports;
